export const resourceCategories = [
  {
    slug: "guides",
    icon: "BookOpen",
    seoTitle: "Cybersecurity Guides & Practical Playbooks | Aliwer",
    seoDescription:
      "Practical cybersecurity guides and playbooks from Aliwer — actionable steps to assess, secure, and prove your security posture.",
    title: "Guides & Playbooks",
    intro: "Practical, step-by-step guides to help your team assess risk and implement strong controls.",
  },
  {
    slug: "reports",
    icon: "FileBarChart",
    seoTitle: "Cybersecurity Reports & Risk Research | Aliwer",
    seoDescription:
      "Cybersecurity reports and risk research from Aliwer covering threats, trends, and practical mitigations.",
    title: "Reports & Research",
    intro: "In-depth reports and risk research on the threats and trends shaping security programs.",
  },
  {
    slug: "checklists",
    icon: "ListChecks",
    seoTitle: "Cybersecurity Checklists | Aliwer",
    seoDescription:
      "Downloadable cybersecurity checklists from Aliwer to benchmark and improve your security posture.",
    title: "Checklists",
    intro: "Concise checklists you can use to benchmark and improve your security posture.",
  },
  {
    slug: "blog",
    icon: "PenLine",
    seoTitle: "Aliwer Cybersecurity Insights & Engineering Blog",
    seoDescription:
      "Insights and engineering perspectives from the Aliwer team on cybersecurity, cloud, AI, and building secure systems.",
    title: "Insights & Engineering Blog",
    intro: "Perspectives from our team on cybersecurity, cloud, AI, and building secure systems.",
  },
];
